import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/procedure//icon_arrow-left_black.svg'
import _imports_1 from '../assets/images/joyworks_logo3.png'


const _withScopeId = n => (_pushScopeId("data-v-2734f424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity_wrapper" }, null, -1))
const _hoisted_4 = { class: "form_container" }
const _hoisted_5 = { class: "section1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "뒤로", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "text_box" }
const _hoisted_10 = { class: "user_text" }
const _hoisted_11 = { class: "text_highlight" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_title_text" }, "A/S 현재 진행 현황", -1))
const _hoisted_13 = { class: "section2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "list_time" }
const _hoisted_16 = { class: "list_text" }
const _hoisted_17 = { class: "text_hightlight_black" }
const _hoisted_18 = { class: "text_hightlight_blue" }

import router from "@/router";
import repairAPI from "@/api/repairAPI";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import authAPI from "@/api/authAPI";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetailList',
  setup(__props) {

const store = useStore();
const userInfo = ref();
const repairList: any = ref([]);
const detailPage = (data: any) => {
  console.log("data", data);
  router.push({ name: "clientDetail", params: { SEQ_NO: data.SEQ_NO } });
};
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};

onMounted(() => {
  checkSession();
  userInfo.value = store.getters.getUserInfo;
  repairAPI.GetRepair({ CUS_HP_NO: userInfo.value.EMP_NO }).then((res: any) => {
    repairList.value = res.data.data;
    console.log("repairtList", repairList.value);
  });
});
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", { class: "section_header_wrap" }, [
          _createElementVNode("div", {
            onClick: goBack,
            class: "back_btn_box"
          }, _hoisted_8),
          _createElementVNode("img", {
            class: "img_logo",
            src: _imports_1,
            style: {"cursor":"pointer"},
            onClick: goHome,
            alt: ""
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(userInfo.value?.EMP_NO), 1),
            _createTextVNode(" 님 ")
          ]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repairList.value, (data) => {
          return (_openBlock(), _createElementBlock("div", {
            key: data.SEQ_NO,
            onClick: ($event: any) => (detailPage(data)),
            class: "list_box"
          }, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(data.DATES), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(data.ITM_NAME), 1),
              _createTextVNode(" 상품 AS가 "),
              _createElementVNode("span", _hoisted_18, _toDisplayString(data.E_STATUS), 1),
              _createTextVNode(" 되었습니다. ")
            ])
          ], 8, _hoisted_14))
        }), 128))
      ])
    ])
  ]))
}
}

})